<template>
    <div>
        Wir leiten sie weiter auf Ihren Schichtplan
    </div>
</template>

<script>
export default {
    mounted(){
        this.$store.getters.scopes.forEach((scope) => {
            if (scope.startsWith("OU_")) {
                this.$router.push(`/${parseInt(scope.substring(3))}`);
            }
      });
    }
}
</script>